/* eslint-disable @nx/enforce-module-boundaries */
import { AspectRatio, buildDynamicRenditionPath, HeightRatioFromAspectRatio } from '@marriott/mi-web-ui-kit';

type DMKind = 'square' | 'wide' | 'tall';

//TODO: for PDC card specific as of now, need to extend this to support other card types
export const buildDynamicMediaNode = (assetUrl?: string, kind: DMKind = 'square', altText?: string) => {
  if (!assetUrl) return;
  const aspect =
    kind === 'wide' ? AspectRatio.WIDE_HOR : kind === 'tall' ? AspectRatio.CLASSIC_VER : AspectRatio.SQUARE;

  const widthXL = 1200;
  const widthLG = 992;
  const widthMD = 768;
  const widthSM = 576;

  const ratio = (HeightRatioFromAspectRatio.get(aspect) as number) || 1;

  const xlSrcSet = buildDynamicRenditionPath(assetUrl, aspect, widthXL);
  const lgSrcSet = buildDynamicRenditionPath(assetUrl, aspect, widthLG);
  const mdSrcSet = buildDynamicRenditionPath(assetUrl, aspect, widthMD);
  const smSrcSet = buildDynamicRenditionPath(assetUrl, aspect, widthSM);

  return {
    altText: altText || '',
    assetPath: assetUrl,
    enableSmartCrop: true,
    dynamic: true,
    renditions: [
      {
        renditionPath: xlSrcSet,
        dynamic: true,
        mediaValue: `${widthXL}px`,
        mediaQuery: 'min-width',
        damPath: assetUrl,
        width: widthXL,
        height: Math.round(widthXL / ratio),
      },
      {
        renditionPath: lgSrcSet,
        dynamic: true,
        mediaValue: `${widthLG}px`,
        mediaQuery: 'min-width',
        damPath: assetUrl,
        width: widthLG,
        height: Math.round(widthLG / ratio),
      },
      {
        renditionPath: mdSrcSet,
        mediaQuery: 'min-width',
        dynamic: true,
        mediaValue: `${widthMD}px`,
        damPath: assetUrl,
        width: widthMD,
        height: Math.round(widthMD / ratio),
      },
      {
        renditionPath: smSrcSet,
        mediaQuery: 'min-width',
        dynamic: true,
        mediaValue: `${widthSM}px`,
        damPath: assetUrl,
        width: widthSM,
        height: Math.round(widthSM / ratio),
      },
    ],
    damPath: assetUrl,
  };
};
